// source: wo_install_date_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var wo_common_message_pb = require('./wo_common_message_pb.js');
goog.object.extend(proto, wo_common_message_pb);
goog.exportSymbol('proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate', null, global);
goog.exportSymbol('proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError', null, global);
goog.exportSymbol('proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult', null, global);
goog.exportSymbol('proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.displayName = 'proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.displayName = 'proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.displayName = 'proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.displayName = 'proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
serviceType: jspb.Message.getFieldWithDefault(msg, 2, ""),
contractName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate;
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServiceType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string service_type = 2;
 * @return {string}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.getServiceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.setServiceType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string contract_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.toObject = function(includeInstance, msg) {
  var f, obj = {
workOrdersList: jspb.Message.toObjectList(msg.getWorkOrdersList(),
    proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.toObject, includeInstance),
date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
remove: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
all: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate;
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate;
      reader.readMessage(value,proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.deserializeBinaryFromReader);
      msg.addWorkOrders(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemove(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRemove();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAll();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * repeated WorkOrderInstallDate work_orders = 1;
 * @return {!Array<!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate>}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.getWorkOrdersList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate>} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} returns this
*/
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.setWorkOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.addWorkOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.WorkOrderInstallDate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.clearWorkOrdersList = function() {
  return this.setWorkOrdersList([]);
};


/**
 * optional google.protobuf.Timestamp date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} returns this
*/
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.hasDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool remove = 3;
 * @return {boolean}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.getRemove = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.setRemove = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool all = 4;
 * @return {boolean}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.getAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate.prototype.setAll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.toObject = function(includeInstance, msg) {
  var f, obj = {
computedList: jspb.Message.toObjectList(msg.getComputedList(),
    wo_common_message_pb.WorkOrder.toObject, includeInstance),
errorList: jspb.Message.toObjectList(msg.getErrorList(),
    proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult;
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new wo_common_message_pb.WorkOrder;
      reader.readMessage(value,wo_common_message_pb.WorkOrder.deserializeBinaryFromReader);
      msg.addComputed(value);
      break;
    case 2:
      var value = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError;
      reader.readMessage(value,proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.deserializeBinaryFromReader);
      msg.addError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComputedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      wo_common_message_pb.WorkOrder.serializeBinaryToWriter
    );
  }
  f = message.getErrorList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder computed = 1;
 * @return {!Array<!proto.Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder>}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.getComputedList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder>} */ (
    jspb.Message.getRepeatedWrapperField(this, wo_common_message_pb.WorkOrder, 1));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder>} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} returns this
*/
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.setComputedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.addComputed = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.WFMS.WorkOrderExecution.Common.v1.WorkOrder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.clearComputedList = function() {
  return this.setComputedList([]);
};


/**
 * repeated InstallDateError error = 2;
 * @return {!Array<!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError>}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.getErrorList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError, 2));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError>} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} returns this
*/
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.setErrorList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.addError = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult.prototype.clearErrorList = function() {
  return this.setErrorList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.toObject = function(includeInstance, msg) {
  var f, obj = {
workOrderName: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError;
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkOrderName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkOrderName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string work_order_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.prototype.getWorkOrderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.prototype.setWorkOrderName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateError.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1);
